var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 25,
    viewBox: "0 0 167 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffe92f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-877 -1138)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,0l4.05,8.393L27,9.549l-6.947,6.343L21.843,25,13.5,20.528,5.157,25l1.79-9.107L0,9.549,9.45,8.393Z",
    transform: "translate(912 1138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,0l4.05,8.393L27,9.549l-6.947,6.343L21.843,25,13.5,20.528,5.157,25l1.79-9.107L0,9.549,9.45,8.393Z",
    transform: "translate(982 1138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,0l4.05,8.393L27,9.549l-6.947,6.343L21.843,25,13.5,20.528,5.157,25l1.79-9.107L0,9.549,9.45,8.393Z",
    transform: "translate(877 1138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,0l4.05,8.393L27,9.549l-6.947,6.343L21.843,25,13.5,20.528,5.157,25l1.79-9.107L0,9.549,9.45,8.393Z",
    transform: "translate(947 1138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.5,0l4.05,8.393L27,9.549l-6.947,6.343L21.843,25,13.5,20.528,5.157,25l1.79-9.107L0,9.549,9.45,8.393Z",
    transform: "translate(1017 1138)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialStars);
export default __webpack_public_path__ + "static/media/testimonial-stars.d33fd4645d6404a13dd99d5477cc5168.svg";
export { ForwardRef as ReactComponent };